import i18n from 'i18next';
import { i18nInitGenerator, trEnv, locale as baseLocale } from 'ion-lib';
import locale from './locale';

const { mandant } = trEnv;

const config = {
  spkStationaerGlas: ['spkIfilialeGlas', `${mandant}Glas`, 'vghGlas', 'spkStationaer', 'spkIfiliale', mandant, 'vgh'],
  spkIfilialeGlas: [`${mandant}Glas`, 'vghGlas', 'spkIfiliale', mandant, 'vgh'],
  vghGlas: ['vghGlas', mandant, 'vgh'],
  oesaGlas: ['oesaGlas', mandant, 'vghGlas', 'vgh'],
  oevbGlas: ['oevbGlas', mandant, 'vghGlas', 'vgh'],
  oevoGlas: ['oevoGlas', mandant, 'vghGlas', 'vgh'],
};

i18n.init(i18nInitGenerator(baseLocale, locale, config));

export default i18n;
